import { render, staticRenderFns } from "./FirmSearch.vue?vue&type=template&id=22812145&scoped=true&"
import script from "./FirmSearch.vue?vue&type=script&lang=js&"
export * from "./FirmSearch.vue?vue&type=script&lang=js&"
import style0 from "./FirmSearch.vue?vue&type=style&index=0&id=22812145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22812145",
  null
  
)

export default component.exports